import SneakPeekOnboarding from './SneakPeekOnboarding';
export default SneakPeekOnboarding;